export default __webpack_public_path__ + "static/media/icon6.1b20ced0.png";